import Vue from 'vue'
import Cookies from 'js-cookie'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

let isInited = false

export const initMonitor = function() {
  if (isInited) {
    return
  }

  const config = {
    dsn: 'https://dc5a3570f723499cbdc16709689c8304@sentry.8btc-ops.com/22',
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true
      })
    ]
  }

  const _matCookie = Cookies.get('_mat')
  if (_matCookie && _matCookie !== 'unset') {
    config.environment = _matCookie
  }

  if (process.env.VUE_APP_VERSION && process.env.VUE_APP_GITHASH) {
    config.release = `matcloud_edu@v${process.env.VUE_APP_VERSION}_${process.env.VUE_APP_GITHASH}`
  }

  if (process.env.NODE_ENV === 'production') {
    Sentry.init(config)
  }

  isInited = true
}

export default {
  setUser: Sentry.setUser
}
